import * as Segment from './segmentEvents';
export default Segment;